import DateUtil from "../../../utils/DateUtil";

export default class MaxDateValidator {

    getErrorMessage(prop) {
        return "Field should be before than or equal to " + DateUtil.formatDateMMM(prop);
    }

    validate(value, prop) {
        if (value === null || value === undefined) {
            return true;
        }
        if (prop === null || prop === undefined) {
            return true;
        }

        return DateUtil.isSameOrBefore(value, prop);
    }

}